import { BaseEditViewStore} from 'core/stores';
import { FacilityOrderTemplateItemNewFlowNoteModalForm } from 'application/facility-order-new-flow/forms';
import { FacilityOrderTemplateItemService } from "application/facility-order/services";

import { action } from "mobx";

class FacilityOrderTemplateItemNewFlowNoteModalStore extends BaseEditViewStore {
    constructor(rootStore, componentProps) {
        const facilityOrderTemplateItem = componentProps.modalParams.data.facilityOrderTemplateItem;
        super(rootStore, {
            name: 'facility-order-template-item-edit-note-modal',
            Form: FacilityOrderTemplateItemNewFlowNoteModalForm,
            id: facilityOrderTemplateItem.id,
            actions: () => {
                return {
                    get: async() =>{
                        return facilityOrderTemplateItem;
                    }
                }
            },
            FormClass: FacilityOrderTemplateItemNewFlowNoteModalForm
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.isUpdate = this.modalParams.data.isUpdate;
        this.facilityOrderTemplateItem = facilityOrderTemplateItem;

        this.facilityOrderTemplateItemService = new FacilityOrderTemplateItemService(rootStore.application.baasic.apiClient);
    }

    @action.bound
    async updateResource(resource) {
        this.form.setFieldsDisabled(true);
        try {
            this.facilityOrderTemplateItem.note = resource.note;

            if(this.isUpdate){
                await this.facilityOrderTemplateItemService.update(this.facilityOrderTemplateItem);
            }

            this.form.setFieldsDisabled(false);
            this.modalParams.close();
            await setTimeout(() => this.notifySuccessUpdate(this.name), 10);
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }

    @action.bound
    notifySuccessUpdate(name) {
        this.rootStore.notificationStore.success('FACILITY_ORDER_NEW_FLOW.EDIT.ITEM_NOTE.SUCCESS_UPDATE', name);
    }
}

export default FacilityOrderTemplateItemNewFlowNoteModalStore;
